<template>
  <messenger-chat-message-layout
    direction="incomming"
    :message-time="message.messageTime"
  >
    <span
      v-safe-html="messageHtml"
      class="break-word"
    />
    <messenger-chat-message-info-compensator :message-time="message.messageTime" />
  </messenger-chat-message-layout>
</template>

<script lang="ts" setup>
import MessengerChatMessageLayout from '@widgets/messenger/components/messages/MessengerChatMessageLayout.vue'
import type { MessengerAutoReplyMessageListItem } from '@widgets/messenger/types/chat/message'
import { useWidgetChatMessageText } from '@widgets/messenger/compositions/useWidgetChatMessageText'
import MessengerChatMessageInfoCompensator from '@widgets/messenger/components/messages/MessengerChatMessageInfoCompensator.vue'

const props = defineProps<{
  message: MessengerAutoReplyMessageListItem
}>()

const { messageHtml } = useWidgetChatMessageText(() => props.message.text)
</script>
